import {HTTP_UNAUTHORIZED} from "./http.error";
import ClientError from "./client.error";

export default class UnauthorizedError extends ClientError {
    /**
     * Constructor
     * @param message {string}
     * @param [response] {*}
     * @param [previous] {Error}
     */
    constructor(message, response, previous) {
        super(HTTP_UNAUTHORIZED, message, response, previous);
        this.name = 'UnauthorizedError';
    }
}